<template>
  <card class="text-center">
    <h3 class="mb-4">Página no encontrada</h3>

    <div class="links">
      <router-link :to="{ name: 'home' }">
        Ir al inicio
      </router-link>
    </div>
  </card>
</template>

<script>
export default {
  name: 'NotFound',
  layout: 'basic-layout'
}
</script>
